module.exports = __webpack_public_path__ + "img/delete-uploader-icon.335d512b.svg";